<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="$t('自清洁')"
    width="500px"
    class="self-cleaning"
    top="30vh"
  >
    <HTForm v-bind="formOptions" :i18nPath="i18nPath"></HTForm>
  </el-dialog>
</template>

<script>
import HTForm from '@/components/form/index.vue';
import { getSelfCleaningStatus, selfCleaning } from '@/api/devices';
import { awaitTo } from '@/utils/utils';

export default {
  components: {
    HTForm
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {
      i18nPath: 'part',
      status: 0,
      formOptions: {
        inline: true,
        config: {
          labelWidth: '',
          span: 18,
          options: [
            {
              type: 'select',
              prop: 'cleanTime',
              labelNeedTranslation: true,
              dataKey: 'cleanTimeList',
              placeholder: '请选择',
              label: '清洁时间'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: () => this.$t(['确定', '清洁中'][this.status]),
                loading: false,
                disabled: () => this.status == 1,
                type: 'primary',
                handler: async ({ data, setLoading, getFormRef }) => {
                  const formRef = getFormRef();

                  const valid = await formRef.validate();

                  if (!valid) return false;

                  setLoading(true);

                  await this.selfCleaning(data);

                  setLoading(false);
                }
              }
            ]
          }
        },

        model: {
          cleanTime: 1
        },
        dataSource: {
          cleanTimeList: Array(6)
            .fill('')
            .map((_e, i) => ({ label: `${i + 1}分钟`, value: i + 1 }))
        },
        rules: {
          cleanTime: [{ required: true, message: '请选择清洁时间', trigger: 'blur' }]
        }
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    },
    async selfCleaning(data) {
      const [err, res] = await awaitTo(
        selfCleaning({
          sn: this.sn,
          selfCleanTime: data.cleanTime
        })
      );

      if (err) {
        console.log(err);
      } else if (res?.message) {
        this.$message.info(this.$t('自清洁中'));
      }

      this.handleClose();
    },
    async getSelfCleaningStatus() {
      const [err, res] = await awaitTo(getSelfCleaningStatus(this.sn));

      if (err) {
        return console.log(err);
      }

      this.status = res.data;
    }
  },
  mounted() {
    document.body.appendChild(this.$el);

    this.getSelfCleaningStatus();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.sell-cleaning {
  box-sizing: border-box;

  .el-dialog {
    height: calc(100vh - 20vh);

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .m-table {
      height: calc(100% - 60px);

      .el-table {
        height: calc(100% - 55px);

        &__body-wrapper {
          height: calc(100% - 48px);
        }
      }
    }
  }
}
</style>
